import {LOOKUP_API_ENDPOINT} from "@/scripts/components/application-form/constants"
import {getFormattedListOfBusinesses} from "@/scripts/components/application-form/helpers"
import $ from 'jquery'
import {isAu} from '@/scripts/util/countryCheck'

export function setClickEventToBusinessItem(elements) {
    const {
        ABNResultWrapper,
        confirmedBusinessDetailsContainer,
        confirmationBoxIsLegalNameValue,
        confirmationBoxLegalNameValue,
        confirmationBoxBusinessNumberValue,
        ABNInput,
        ABNTradingName,
        ABNTextSearchInput,
        hiddenBusinessNumberInputField,
        hiddenLegalNameInputField,
        hiddenPrivateLegalNameInputField,
        next: navigationNextButton,
    } = elements
    const clickableListItem = document.querySelectorAll(`.item-clickable`)
    const businessRegisterLookupLink = document.getElementById(`abn_lookup_link`)
    if (clickableListItem && clickableListItem.length > 0) {
        clickableListItem.forEach(listItem => {
            listItem.addEventListener(`click`, () => {
                const {
                    legalName,
                    privateLegalName,
                    businessNumber
                } = listItem.dataset

                ABNResultWrapper.classList.add(`hide`)
                businessRegisterLookupLink.classList.add(`hide`)
                navigationNextButton.classList.remove(`disabled`)
                ABNInput.parentElement.classList.add(`is-completed`)
                confirmedBusinessDetailsContainer.classList.remove(`hide`)
                ABNTextSearchInput.parentElement.classList.add(`is-completed`)

                if (listItem.dataset.datasettradingName) {
                    ABNTradingName.innerHTML = listItem.dataset.datasettradingName
                } else {
                    document.querySelector(`[data-trading-title]`).classList.add(`hide`)
                    ABNTradingName.classList.add(`hide`)
                }

                // Business Number
                if (
                    businessNumber &&
                    confirmationBoxBusinessNumberValue &&
                    hiddenBusinessNumberInputField
                ) {
                    confirmationBoxBusinessNumberValue.innerHTML = businessNumber
                    hiddenBusinessNumberInputField.value = businessNumber
                } else {
                    if (confirmationBoxBusinessNumberValue) {
                        confirmationBoxBusinessNumberValue.innerHTML = ``
                    }
                    if (hiddenBusinessNumberInputField) {
                        hiddenBusinessNumberInputField.value = ``
                    }
                }
                // Legal Name Hidden Input
                if (legalName && hiddenLegalNameInputField) {
                    hiddenLegalNameInputField.value = legalName
                } else {
                    if (hiddenLegalNameInputField) {
                        hiddenLegalNameInputField.value = ``
                    }
                }
                // NZ Only. Private Legal Name Hidden Input
                if (hiddenPrivateLegalNameInputField && privateLegalName) {
                    hiddenPrivateLegalNameInputField.value = privateLegalName
                } else {
                    if (hiddenPrivateLegalNameInputField) {
                        hiddenPrivateLegalNameInputField.value = ``
                    }
                }

                if (listItem.dataset.isLegalName === `true`) {
                    confirmationBoxIsLegalNameValue.innerHTML = `Legal Name:`
                } else {
                    confirmationBoxIsLegalNameValue.innerHTML = `Business Name:`
                }

                if (privateLegalName) {
                    confirmationBoxLegalNameValue.innerHTML = privateLegalName
                } else if (legalName) {
                    confirmationBoxLegalNameValue.innerHTML = legalName
                } else {
                    if (confirmationBoxLegalNameValue) {
                        confirmationBoxLegalNameValue.innerHTML = ``
                    }
                }

                if (isAu()) {
                    document.getElementById(`business_information_loading`).classList.remove(`hide`)
                    document.getElementById(`businessInformationLoaded`).value = null
                    // AU sites - do ABN based lookup to see if it's a TRUST.
                    let ajaxOptions = {
                        url: `${LOOKUP_API_ENDPOINT}/api/abn/ABN/`,
                        type: `POST`,
                        success: (response) => {
                            let businesses = getFormattedListOfBusinesses(response)
                            if (typeof businesses === `object`) {
                                businesses = Object.values(businesses)
                            }
                            let business = businesses[0]
                            document.getElementById(`business_information_loading`).classList.add(`hide`)
                            document.getElementById(`businessInformationLoaded`).value = `y`
                            let el = document.getElementById(`business_information_trust_inputs`)
                            if (business.entityType.entityDescription.toLowerCase().includes(`trust`)) {
                                el.innerHTML = ``
                                let html = `<p>It looks like your business is listed as a trust. We'll need to collect some extra information</p>`
                                html += `<div class="margin-bottom-3x margin-top-3x">`
                                html += `<label for="trustee_type">Please choose the Trustee Type. </label>`
                                html += `<select name="trustee_type" id="trustee_type" data-required>`
                                html += `<option value="" disabled hidden selected>-- Please Choose --</option>`
                                html += `<option value="company">Company</option>`
                                html += `<option value="individual">Individual</option>`
                                html += `</select>`
                                html += `</div>`
                                html += `<div id="acnInputs" class="hide margin-bottom-3x">`
                                html += `<label for="trustee_acn">Please enter the ACN of the company acting as the trustee</label>`
                                html += `<input type="text" name="trustee_acn" id="trustee_acn" />`
                                html += `<div class="margin-bottom-3x"><input type="hidden" name="valid_acn" id="valid_acn" />`
                                html += `<p id="acnErrorBox" class="error hide">Hmmm, that doesn't look like a valid ACN.</p>`
                                html += `</div></div>`
                                html += `<div id="trusteeNameInputs" class="hide margin-bottom-3x">`
                                html += `<label for="trustee_name">Trustee Name:</label>`
                                html += `<input type="text" readonly name="trustee_name" id="trusteeNameInput">`
                                html += `</div>`
                                el.innerHTML = html
                                el.classList.remove(`hide`)
                                document.getElementById(`trustee_type`).addEventListener(`input`, event => {
                                    let firstNameInput = document.getElementById(`first_name`)
                                    let lastNameInput = document.getElementById(`last_name`)

                                    if (event.target.value === `company`) {
                                        document.getElementById(`acnInputs`).classList.remove(`hide`)
                                        document.getElementById(`trustee_acn`).setAttribute(`data-required`, `true`)
                                        document.getElementById(`valid_acn`).setAttribute(`data-required`, `true`)

                                        document.getElementById(`trusteeNameInputs`).classList.add(`hide`)
                                        document.getElementById(`trusteeNameInput`).removeAttribute(`data-required`)
                                        document.getElementById(`trusteeNameInput`).value = ``
                                    } else {
                                        document.getElementById(`acnInputs`).classList.add(`hide`)
                                        document.getElementById(`trustee_acn`).removeAttribute(`data-required`)
                                        document.getElementById(`valid_acn`).removeAttribute(`data-required`)

                                        document.getElementById(`trusteeNameInputs`).classList.remove(`hide`)
                                        document.getElementById(`trusteeNameInput`).setAttribute(`data-required`, `true`)
                                        document.getElementById(`trusteeNameInput`).value =  `${firstNameInput.value} ${lastNameInput.value}`
                                    }
                                })
                                document.getElementById(`trustee_acn`).addEventListener(`input`, event => {
                                    let valid = false
                                    let number = event.target.value.trim()

                                    if (number.length === 9 && /^\d*$/.test(number) ) {
                                        let digits = number.split(``)
                                        let weights = [8,7,6,5,4,3,2,1]
                                        let sum = 0

                                        weights.forEach((value, index) => {
                                            sum += value * parseInt(digits[index])
                                        })

                                        let checksum = 10 - (sum % 10)
                                        if (checksum === 10) {
                                            checksum = 0
                                        }

                                        valid = checksum === parseInt(digits[8])
                                    }

                                    document.getElementById(`valid_acn`).value = valid ? `y` : null
                                    if (valid) {
                                        document.getElementById(`acnErrorBox`).classList.add(`hide`)
                                    } else {
                                        document.getElementById(`acnErrorBox`).classList.remove(`hide`)
                                    }
                                })
                            } else {
                                el.innerHTML = ``
                            }
                        },
                        error: response => {

                        },
                        data: {
                            ABN: businessNumber
                        }
                    }
                    $.ajax(ajaxOptions)
                }
            })
        })
    }
}
